import React from "react";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCreateMunicipalityMutation } from "store/services/LocationsApi/municipalityApi";
import MunicipalityForm from "./municipalityComponents/MunicipalityForm";

const MunicipalityCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Municipality", path: "/app/crm/municipality/list" },
    { title: "New Municipality" },
  ];

  const [createMunicipality, { isLoading: creatingMunicipality, error }] =
    useCreateMunicipalityMutation();

  const handleMunicipalityCreate = async (data) => {
    try {
      await createMunicipality({
        ...data,
      }).unwrap();
      navigate(breadcrumbs[0].path);
      toast.success("Municipality created successfully");
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create Municipality!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingMunicipality}>
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <MunicipalityForm
          isBusy={creatingMunicipality}
          onSubmit={handleMunicipalityCreate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default MunicipalityCreateScreen;
